import { Link } from 'react-router-dom';
import { featuredArticles, articles } from '@/mocks/articles';

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function HotContentGrid() {
  const mainFeatured = featuredArticles.slice(0, 3);
  const regularArticles = articles.filter(a => !a.isFeatured).slice(0, 3);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" aria-label="热点内容">
      <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider">
              本周精选
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold italic text-foreground-950">
              热点追踪
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-md lg:text-right">
            汇集全网最热娱乐资讯，明星八卦、网红爆料、黑料吃瓜一网打尽，每日实时更新，不容错过的精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mainFeatured.map((article, index) => {
            const isMiddle = index === 1;
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group block rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer ${
                  isMiddle
                    ? 'bg-secondary-900'
                    : 'bg-background-100 hover:bg-background-200/70'
                }`}
              >
                {isMiddle ? (
                  <div className="relative h-[240px] md:h-[280px] flex flex-col items-center justify-center p-8 text-center">
                    <span className="w-16 h-16 flex items-center justify-center">
                      <i className="ri-fire-line text-4xl text-accent-400"></i>
                    </span>
                    <h3 className={`mt-4 text-lg md:text-xl font-bold leading-snug ${
                      isMiddle ? 'text-background-50' : 'text-foreground-950'
                    }`}>
                      {article.title}
                    </h3>
                    <p className={`mt-3 text-sm leading-relaxed line-clamp-3 ${
                      isMiddle ? 'text-secondary-300' : 'text-foreground-600'
                    }`}>
                      {article.excerpt}
                    </p>
                    <div className="mt-5 flex items-center gap-4">
                      <span className="inline-block px-3 py-1 bg-accent-400 text-secondary-950 text-xs font-semibold rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className={`text-xs ${isMiddle ? 'text-secondary-400' : 'text-foreground-500'}`}>
                        {article.date} · {article.readTime}
                      </span>
                    </div>
                    {article.isVideo && (
                      <span className={`absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full ${
                        isMiddle ? 'bg-background-50/15 text-background-50' : 'bg-foreground-950/10 text-foreground-700'
                      }`}>
                        <i className="ri-play-fill text-lg"></i>
                      </span>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="relative w-full h-[240px] md:h-[280px] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading={index === 0 ? 'eager' : 'lazy'}
                      />
                      {article.isVideo && (
                        <span className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50">
                          <i className="ri-play-fill text-lg"></i>
                        </span>
                      )}
                    </div>
                    <div className="p-5">
                      <span className="inline-block px-3 py-1 bg-accent-400 text-secondary-950 text-xs font-semibold rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                      <h3 className="mt-3 text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                        {article.title}
                      </h3>
                    </div>
                  </>
                )}
              </Link>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          {regularArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500">
                    <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                      <i className="ri-calendar-line text-xs"></i>
                    </span>
                    {article.date}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {formatViews(article.views)}
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/weekly-hot"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-background-50 text-sm font-semibold rounded-full transition-all duration-300 hover:bg-foreground-800 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}